/* Villionaire — theme.js
   Global behaviors only. Section-specific interaction scripts are
   co-located in their section files. */
(function () {
  'use strict';

  if (window.Villionaire && window.Villionaire.settings && window.Villionaire.settings.enableScrollReveal) {
    var revealTargets = document.querySelectorAll('[data-reveal]');
    if (revealTargets.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      revealTargets.forEach(function (el) { observer.observe(el); });
    } else {
      revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  // Quick add (collection grid product cards)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    if (btn.getAttribute('data-needs-options') === 'true') {
      var card = btn.closest('[data-product-card]');
      var link = card && card.querySelector('.product-card__title');
      if (link) window.location.href = link.getAttribute('href');
      return;
    }

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || !window.Villionaire || !window.Villionaire.routes) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';

    fetch(window.Villionaire.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added';
        if (window.Villionaire.cart && window.Villionaire.cart.refresh) {
          window.Villionaire.cart.refresh();
        }
        setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1500);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });
})();
